import API from 'services/api';

export const getPropertyTypesFromRoot = () => API.get('api/root/property-types/all');
